import { render } from "./GruposListarPerfil.vue?vue&type=template&id=35085808&scoped=true&ts=true"
import script from "./GruposListarPerfil.vue?vue&type=script&lang=ts"
export * from "./GruposListarPerfil.vue?vue&type=script&lang=ts"

import "./GruposListarPerfil.vue?vue&type=style&index=0&id=35085808&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35085808"]])

export default __exports__